import {getConf} from "@configuratorware/configurator-frontendgui/App/configuration";
import {Services} from "@configuratorware/configurator-frontendgui/App/ServiceLocator";
import {EventTypes} from "@configuratorware/configurator-frontendgui/App/Constant";
import {setVisible} from "@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions";
import {isArray} from "lodash";
import {
    fetchConfiguration,
    fetchConfigurationVariants, receiveConfiguration
} from "@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions";
import * as apiActions from "@configuratorware/configurator-frontendgui/App/Reducers/Actions";


export const fetchConfigurationByCode = (code, checkValidation = true) => {
    return apiActions.fetchData('configuration/loadbyconfigurationcode/' + code + '?clear_amounts=1', receiveConfiguration, {
        checkValidation,
    },);
};

export const fetchInitialConfiguration = () => (dispatch, getState) => {
    const { loadCode, loadIdentifier } = getState().configurator;
    const defaultLoadIdentifier = getConf('defaultLoadIdentifier');

    if (loadCode) {
        // Load the options by code
        return dispatch(fetchConfigurationByCode(loadCode)).then(configuration => {
            Services.analytics.triggerEvent(EventTypes.load_item, configuration.data.item.identifier);
        });
    } else if (getConf('loadVariantsFirst')) {
        // Load variants by identifier
        dispatch(setVisible('configurationvariantSelection', true));

        return dispatch(fetchConfigurationVariants(loadIdentifier)).then(result => {
            // if the result contains error just return, do nothing else
            if (result.error) {
                return;
            }

            const { configurationvariants, loadIdentifier } = getState().configurator;

            // If there is only one variant or the list is empty, fall back to fetchConfiguration
            if (isArray(configurationvariants)) {
                if (configurationvariants.length === 0) {
                    // Load the options for the initially selected optionclassification
                    dispatch(fetchConfiguration(loadIdentifier));
                }
                if (configurationvariants.length === 1) {
                    // There is only one variant in the list, just load it
                    dispatch(fetchConfiguration(configurationvariants[0].identifier));
                }
            }
        });
    } else if (loadIdentifier === '__empty__') {
        return Promise.resolve();
    } else if (loadIdentifier) {
        return dispatch(fetchConfiguration(loadIdentifier));
    } else if (defaultLoadIdentifier) {
        return dispatch(fetchConfiguration(defaultLoadIdentifier));
    }
};

